import { ToggleButtonGroup } from "@mui/material";
import { ChartBarIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import { SortButton } from "@/components/SortButton/SortButton";
import {
  FlightsSortOptions,
  type FlightsSortValue,
} from "@/features/flights/types/types";
import { SortOrder } from "@/types/enums";

type Props = {
  value: FlightsSortValue;
  onChange: (newValue: FlightsSortValue) => void;
};

function FlightsSort({ value, onChange }: Props) {
  const t = useTranslations();

  return (
    <div className="relative w-full">
      <ToggleButtonGroup
        orientation="vertical"
        fullWidth
        exclusive
        size="small"
        color="primary"
        aria-label={t("sortOptions")}
      >
        <SortButton
          value={{ field: FlightsSortOptions.PRICE, order: SortOrder.ASC }}
          isSelected={
            value.field === FlightsSortOptions.PRICE &&
            value.order === SortOrder.ASC
          }
          onChange={onChange}
        >
          <ChartBarIcon size={16} className="rotate-90" aria-hidden />
          {t("flights.cheapFirst")}
        </SortButton>

        <SortButton
          value={{ field: FlightsSortOptions.PRICE, order: SortOrder.DESC }}
          isSelected={
            value.field === FlightsSortOptions.PRICE &&
            value.order === SortOrder.DESC
          }
          onChange={onChange}
        >
          <ChartBarIcon
            size={16}
            style={{ transform: "rotate(90deg) scaleX(-1)" }}
            aria-hidden
          />
          {t("flights.expensiveFirst")}
        </SortButton>
      </ToggleButtonGroup>
    </div>
  );
}

export default FlightsSort;
